import {Label} from '@primer/react'
import type React from 'react'

import {TEST_IDS} from '../constants'
import type {CommentAuthorAssociation as GraphQlAuthorAssociation} from './issue-comment/__generated__/IssueCommentHeader.graphql'

type Props = {
  association: GraphQlAuthorAssociation
}

type AssociationHash = Record<string, string>

const MAP_ASSOCIATION: AssociationHash = {
  MEMBER: 'Member',
  OWNER: 'Owner',
  MANNEQUIN: 'Mannequin',
  COLLABORATOR: 'Collaborator',
  CONTRIBUTOR: 'Contributor',
  FIRST_TIME_CONTRIBUTOR: 'First-time contributor',
  FIRST_TIMER: 'First-time GitHub contributor',
  NONE: '',
}

export const CommentAuthorAssociation: React.FC<Props> = ({association}: Props) => {
  return (
    <>
      {MAP_ASSOCIATION[association] && (
        <Label variant="secondary" data-testid={TEST_IDS.commentAuthorAssociation}>
          {MAP_ASSOCIATION[association]}
        </Label>
      )}
    </>
  )
}

try{ CommentAuthorAssociation.displayName ||= 'CommentAuthorAssociation' } catch {}